import { Component, EventEmitter, Input, OnInit, Optional, Output, ChangeDetectionStrategy } from '@angular/core';
import { SidebarService } from '../../services/sidebar.service';
import { AuthService } from '../../services/auth.service';
import { BaseService } from '../../services/base.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-integration-block',
  templateUrl: './integration-block.component.html',
  styleUrls: ['./integration-block.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class IntegrationBlockComponent implements OnInit {
  @Input() data: any = {};
  @Output() onChangeClick = new EventEmitter();

  @Input() title: string = '';
  @Input() bg: string = '#ffffff';
  @Input() color: string = '#000000';
  @Input() dev: boolean = false;
  @Input() new: boolean = false;
  @Input() count: number = 0;
  @Input() active: boolean = false;
  @Input() beta: boolean = false;

  constructor(
    public readonly authService: AuthService,
    public readonly baseService: BaseService,
    private readonly sidebarService: SidebarService,
    private readonly router: Router,
  ) {}

  ngOnInit() {
    if (Object.keys(this.data).length) {
      this.title = this.data.title;
      this.bg = this.data.bg;
      this.color = this.data.color;
      this.dev = this.data.dev;
      this.new = this.data.new;
    }
  }

  click(event: any) {
    this.onChangeClick.emit();
  }
}
